import { Component, OnInit, ElementRef, Renderer } from '@angular/core';

@Component({
  selector: 'background-star',
  template: require('./backgroundStar.component.html'),
  styles: [require('./backgroundStar.component.scss')]
})
export class BackgroundStar implements OnInit {
  public elem;
  public backgroundChild;
  public copyOfElem;
  constructor(private elRef: ElementRef, private renderer: Renderer) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {

    this.elem = this.elRef.nativeElement.querySelector('#starShape');
    this.backgroundChild = Array.prototype.slice.call(this.elem.children);

    this.copyOfElem = [];

    setInterval(() => {

      this.backgroundChild.forEach(element => {
        if (element === this.copyOfElem[0]) {
          this.renderer.setElementClass(element, 'lighting', false);
  
          this.copyOfElem.splice(0, 1);

        }
      });

      const randomIndex = Math.floor(Math.random() * this.backgroundChild.length);
      const randomElem = this.backgroundChild[randomIndex];

      this.copyOfElem.push(randomElem);
      this.renderer.setElementClass(randomElem, 'lighting', true);

    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/backgroundStar/backgroundStar.component.ts